// src/components/SearchPage.js
import React, { useEffect, useState } from 'react';
import { Container, Header, List } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { searchTranscripts, formatUrlPart, getTranscriptId, SITE_BASE_URL } from '../services/api';
import DisclaimerLink from './DisclaimerLink';

const baseUrl = SITE_BASE_URL.replace(/\/$/, '');

const SearchPage = () => {
  const { searchquery } = useParams();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    searchTranscripts(searchquery)
      .then(data => setResults(Array.isArray(data) ? data : []))
      .catch(err => {
        console.error(err);
        setError('Search failed. Please try again.');
        setResults([]);
      })
      .finally(() => setLoading(false));
  }, [searchquery]);

  const title = `Search: ${searchquery} - Blue Compass RV Troubleshooting`;
  const description = `Search results for "${searchquery}" in Blue Compass RV support transcripts. Find resolved troubleshooting guides by brand and model.`;
  const canonicalUrl = `${baseUrl}/search/${encodeURIComponent(searchquery)}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      <main>
    <Container>
      <p style={{ marginBottom: '20px' }}>
        <DisclaimerLink />
      </p>
      <Header as="h1">Search Results for "{searchquery}"</Header>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: '#912b2b' }}>{error}</p>}
      {!loading && !error && results.length === 0 && (
        <p>No results found for "{searchquery}".</p>
      )}
      {!loading && results.length > 0 && (
        <List divided relaxed>
          {results.map(result => {
            const id = getTranscriptId(result);
            const details = result.details && result.details.vehicle ? result.details.vehicle : {};
            const formattedMake = formatUrlPart(details.make);
            const formattedModel = formatUrlPart(details.model);
            if (!id) return null;
            return (
              <List.Item key={id}>
                <List.Content>
                  <List.Header>
                    <Link to={`/brand/${formattedMake}/model/${formattedModel}/${id}`}>
                      {result.title || 'Call Transcript'}
                    </Link>
                  </List.Header>
                  <List.Description />
                </List.Content>
              </List.Item>
            );
          })}
        </List>
      )}
    </Container>
      </main>
    </>
  );
};

export default SearchPage;
